import { ArrowRight } from 'lucide-react';
import { Reveal } from '../components/Reveal';
import { Logo } from '../components/Logo';
import { scrollToId } from '../lib/smoothScroll';

export const CtaBanner = () => (
  <section id="about" className="scroll-mt-20 pb-20 md:pb-28" data-testid="cta-banner-section">
    <div className="container-relay">
      <Reveal>
        <div className="relative overflow-hidden rounded-2xl bg-[#0B1F1A] px-6 py-14 sm:px-12 md:py-16">
          <div
            aria-hidden="true"
            className="pointer-events-none absolute inset-0 opacity-[0.35]"
            style={{
              backgroundImage: 'radial-gradient(rgba(127,191,168,0.16) 1px, transparent 1px)',
              backgroundSize: '22px 22px',
            }}
          />
          <div className="relative flex flex-col items-start gap-10 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-xl">
              <div className="mb-6">
                <Logo dark />
              </div>
              <h2 className="text-3xl font-bold tracking-tight text-[#FAFAF7] sm:text-4xl" data-testid="cta-headline">
                Let&rsquo;s build a better experience for your fleet.
              </h2>
              <p className="mt-4 text-base leading-relaxed text-[#9DB4AA]" data-testid="cta-body">
                Book a demo or start a conversation with our team.
              </p>
              <p className="font-op mt-6 text-[11px] uppercase tracking-[0.22em] text-[#5F7A6F]">
                Digital when it should be. Human when it needs to be.
              </p>
            </div>
            <div className="flex w-full flex-col gap-3 sm:flex-row lg:w-auto lg:flex-col">
              <button data-testid="cta-book-demo" onClick={() => scrollToId('enquiry')} className="btn-primary !bg-[#0F5C4A] hover:!bg-[#13705A] lg:w-56">
                Book a Demo <ArrowRight size={16} />
              </button>
              <button data-testid="cta-contact" onClick={() => scrollToId('enquiry')} className="btn-ghost-dark lg:w-56">
                Contact Us
              </button>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
